<template>
  <div class="special-topic-list">
    <xi-top></xi-top>
      <div class="topic-banner"></div>
      <div class="topic-list-wrapper">
          <div class="topic-list-inner-wrapper">
              <span class="topic-list-title">全部专题</span>
              <div @click="toDetail(topic.id)" v-for="topic in data.items" class="topic-wrapper">
                  <img :src="`${$store.state.UPLOAD_IMG_HOST}${topic.logo}`">
                  <div class="topic-content-wrapper">
                      <span class="topic-title">{{ topic.title }}</span>
                      <span class="topic-duration">{{ topic.startTime|format-date('YYYY-MM-DD') }} ~ {{ topic.endTime|format-date('YYYY-MM-DD') }}</span>
                      <span class="topic-audition-person-time">已有{{ topic.candidateNum }}人参选</span>
                      <p class="topic-desc">{{ topic.description }}</p>
                      <img v-if="!isTopicOver(topic)" :src="`${$store.state.IMG_HOST}topic_status_active@2x.png`" :key="topic.id" class="topic-status">
                      <img v-else :src="`${$store.state.IMG_HOST}topic_status_over@2x.png`" :key="topic.id" class="topic-status">
                  </div>
              </div>
          </div>
          <div class="pagination" v-if="data.pages>=2">
              <el-pagination @current-change="changePage" :current-page="data.pageNum" :page-count="data.pages" layout="prev, pager, next"></el-pagination>
          </div>
      </div>
    <xi-footer></xi-footer>
  </div>
</template>
<script>
  import axios from 'axios';
  import XiFooter from '../components/Footer.vue';
  import XiTop from '../components/Top.vue';
  export default {
    components: {
      axios,
      XiFooter,
      XiTop
    },
    data() {
      return {
        data: {}
      }
    },
    methods: {
      getListInfo (pageIndex) {
        axios.get(`/api/subject/list/${pageIndex}`).then(res => {
          if (res.data.code === 200) {
            this.data = res.data.data;
          }
        });
      },
      toDetail(topicId) {
        this.$router.push({
          name: 'specialTopicDetail',
          params: {
            id: topicId
          }
        })
      },
      changePage(pageIndex) {
        this.data.pageIndex = pageIndex;
        this.getListInfo(pageIndex);
      },
      isTopicOver(topic) {
        const curTime = new Date();
        return curTime > topic.endTime;
      }
    },
    computed: {
    },
    beforeMount() {
      this.getListInfo(1);
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/icons.scss";
    @import "../../sass/specialTopic/list.scss";
</style>



// WEBPACK FOOTER //
// List.vue?7f471cc5